// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionGroup_header__2YWUH","description":"SectionGroup_description__fouQ7"};